import { render, staticRenderFns } from "./TaxcarddetailsNew.vue?vue&type=template&id=1b46f9f9&scoped=true"
import script from "./TaxcarddetailsNew.vue?vue&type=script&lang=js"
export * from "./TaxcarddetailsNew.vue?vue&type=script&lang=js"
import style0 from "./TaxcarddetailsNew.vue?vue&type=style&index=0&id=1b46f9f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46f9f9",
  null
  
)

export default component.exports